import { object, string, ref, boolean } from '@softland/forms/validators';

export const loginValidation = object().shape({
  email: string().email().required(),
  password: string().min(8).required(),
});

export const resetValidation = object().shape({
  newPassword: string()
    .matches(RegExp('^(?=.*?[A-Z])'), 'uppercase')
    .matches(RegExp('[`\\/!@#$%^&*()_+={};\':"|,.<>?~]'), 'symbol')
    .min(8)
    .required(),
  confirmPassword: string()
    .oneOf([ref('newPassword'), undefined], "Passwords don't match")
    .required(),
});

export const twoFaValidation = object().shape({
  setupKey: string(),
  otp: string()
    .required('The field is required')
    .min(6, 'The minimum character count is 6')
    .max(6, 'The minimum character count is 6')
    .matches(/^\d+$/, 'Enter a valid code'),
});

export const otpValidation = object().shape({
  trustDevice: boolean().optional(),
  otp: string()
    .required('The field is required')
    .min(6, 'The minimum character count is 6')
    .max(6, 'The minimum character count is 6')
    .matches(/^\d+$/, 'Enter a valid code'),
});
